<template>
  <div id="ppf">
    <b-row class="mt-4 mb-4">
      <b-col>
        <h3 class="text-center">Paint Protection Film Viewer - Choose a Vehicle to Begin</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12" lg="8">
        <b-row class="mt-2 mb-2">
          <b-col :key="index"
                  v-for="(icon, index) in vehicleTypes"
          class="vehicle-icon">
            <a class="icon text-center" @click="selectVehicle(icon, index)" :class="icon.active ? null : 'active'">
            <b-row>
              <b-col v-if="icon.active">
                <img class="img-fluid" :src="icon.activeIcon+'-active.png'" />
              </b-col>
              <b-col v-else>
                <img class="img-fluid" :src="icon.icon+'.png'" />
              </b-col>
            </b-row>
            <b-row>
              <b-col><p>{{icon.type}}</p></b-col>
            </b-row>
            </a>
          </b-col>
        </b-row>
        <div class="mobile-package-list">
          <b-row class="bg-dark-gray">
            <b-col>
              <p class="text-center font-weight-bold ppf-header-headline">To See Protected Areas, Select a Package Below</p>
              <p class="text-center ppf-header-subline"><small>Option availability is dependent on the vehicle. See your Tint World Store for details.</small></p>
            </b-col>
          </b-row>
          <b-row class="bg-yellow">
            <b-col class="mt-2 mb-2 text-center">
              <b-form-select v-model="selectedPpfOption" class="ppf-option-select w-75 mx-auto text-center font-weight-bold">
                <b-form-select-option value="" selected>Please Select a PPF Coverage Option</b-form-select-option>
                <b-form-select-option v-for="(option,index) in ppfOptions" :key="index" :value="option">{{option.title}}</b-form-select-option>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="selectedPpfOption">
            <b-col>
              <p class="text-center mobile-ppf-description">{{selectedPpfOption.description}}</p>
            </b-col>
          </b-row>
        </div>
        <b-row class="mt-4 mb-2">
          <b-col class="vehicle-ctn">
            <div class="vehicle-image-wrapper">
            <img class="vehicle-image img-fluid" :src="currentVisualizerImage" />
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col class="text-center" v-if="rearView">
            <b-button class="mx-auto btn-tint-world-outline" @click="changeView()" variant="outline-primary">Change to Front View</b-button>
          </b-col>
          <b-col class="text-center" v-else>
            <b-button class="mx-auto btn-tint-world-outline" @click="changeView()" variant="outline-primary">Change to Rear View</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <p class="text-center mt-2"><small>SunTek Gloss and Matte PPF are optically clear, and Altered Black PPF has a gloss black finish.
              Shown in yellow for visuals only.</small></p>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="desktop-package-list">
        <b-card class="accordion-top-copy">
          <p class="text-center font-weight-bold ppf-options-headline">To See Protected Areas, <span class="nobreak">Select a Package Below</span></p>
          <p class="text-center"><small>Option availability is dependent on the vehicle. See your Tint World Store for details.</small></p>
        </b-card>
        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header class="accordion-section-title" role="tab">
              PPF Packages
            </b-card-header>
          </b-card>
          <b-card no-body class="mb-1" v-for="(option,index) in ppfOptions" :key="index">
            <b-card no-body class="mb-1" v-if="index == 4">
              <b-card-header class="accordion-section-title" role="tab">
                PPF Add-ons
              </b-card-header>
            </b-card>
            <b-card-header header-tag="header" class="p-0" role="tab">
              <b-button block variant="info" class="btn-tint-world" :class="option.visible ? 'active-item' : 'collapsed'"
                        :aria-expanded="option.visible ? 'true' : 'false'"
                        :aria-controls="'ppf-option-'+index"
                        @click="selectPPF(option)">{{option.title}}</b-button>
            </b-card-header>
            <b-collapse :id="'ppf-option-'+index" accordion="my-accordion" role="tabpanel" v-model="option.visible">
              <b-card-body class="ppf-copy-container">
                <b-card-text class="ppf-description">{{option.description}}</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

//import axios from "axios";


export default {
  components: {},
  data: () => {
    return {
      //@TODO - Refactor the Vehicle Types / PPF Options to Work with V-Model for Cleaner Implementation
      selectedVehicleType: false,
      selectedPpfOption: false,
      selectedTypeIndex: 0,
      vehicleTypes: [
          {type:'Large Sedan',
            alias:'large-sedan',
            icon:'https://res.cloudinary.com/tint-world/image/upload/t_color_black/custom-assets/PPF%20Visualizer/icons/large-sedan',
            activeIcon: 'https://res.cloudinary.com/tint-world/image/upload/t_color_yellow/custom-assets/PPF%20Visualizer/icons/large-sedan',
            vehicleImageBase: 'https://res.cloudinary.com/tint-world/image/upload/t_ppf_vehicle/custom-assets/PPF%20Visualizer/vehicles/large-sedan/',
            active: true
          },
        {type:'Sedan',
          alias:'sedan',
          icon:'https://res.cloudinary.com/tint-world/image/upload/t_color_black/custom-assets/PPF%20Visualizer/icons/sedan',
          activeIcon: 'https://res.cloudinary.com/tint-world/image/upload/t_color_yellow/custom-assets/PPF%20Visualizer/icons/sedan',
          vehicleImageBase: 'https://res.cloudinary.com/tint-world/image/upload/t_ppf_vehicle/custom-assets/PPF%20Visualizer/vehicles/sedan/',
          active: false
        },
        {type:'Coupe',
          alias:'coupe',
          icon:'https://res.cloudinary.com/tint-world/image/upload/t_color_black/custom-assets/PPF%20Visualizer/icons/coupe',
          activeIcon: 'https://res.cloudinary.com/tint-world/image/upload/t_color_yellow/custom-assets/PPF%20Visualizer/icons/coupe',
          vehicleImageBase: 'https://res.cloudinary.com/tint-world/image/upload/t_ppf_vehicle/custom-assets/PPF%20Visualizer/vehicles/coupe/',
          active: false
         },
        {type:'Truck',
          alias:'truck',
          icon:'https://res.cloudinary.com/tint-world/image/upload/t_color_black/custom-assets/PPF%20Visualizer/icons/truck',
          activeIcon: 'https://res.cloudinary.com/tint-world/image/upload/t_color_yellow/custom-assets/PPF%20Visualizer/icons/truck',
          vehicleImageBase: 'https://res.cloudinary.com/tint-world/image/upload/t_ppf_vehicle/custom-assets/PPF%20Visualizer/vehicles/truck/',
          active: false
          },
        {type:'SUV',
          alias:'suv',
          icon:'https://res.cloudinary.com/tint-world/image/upload/t_color_black/custom-assets/PPF%20Visualizer/icons/suv',
          activeIcon: 'https://res.cloudinary.com/tint-world/image/upload/t_color_yellow/custom-assets/PPF%20Visualizer/icons/suv',
          vehicleImageBase: 'https://res.cloudinary.com/tint-world/image/upload/t_ppf_vehicle/custom-assets/PPF%20Visualizer/vehicles/suv/',
          active: false
          }
        ],
      ppfOptions: [
        {'title':'Ultimate',
         'description':'Get full vehicle coverage with technologically advanced Xpel PPF - a strong, reliable layer of protection against damage caused by flying rocks, salt, insects and other road debris. Have SunTek Altered Black PPF installed on the full vehicle for a complete transformation.',
          'alias': 'full-car',
          visible: false
        },
        {'title':'Supreme',
          'description':'Extend Premium kit benefits to vehicle front end:  protect full hood and fenders, front bumper, mirrors and a-pillars for increased coverage and protection. No visible edges across panels for better aesthetics.',
          'alias': 'supreme',
          visible: true
        },
        {'title':'Premium',
          'description':'Protect leading edge of hood,  partial fenders and mirrors against rock chips, scratches and stains; plus front bumper protection.',
          'alias': 'premium',
          visible: false
        },
        {'title':'Economy',
          'description':'Protect leading edge of hood, partial fenders and mirrors against rock chips, scratches and stains from insects and other solvents.',
          'alias': 'basic',
          visible: false
        },
        {'title':'Wear & Tear Premium',
          'description':'Protect paint behind door handles from ring and key scratches; help prevent damage to door edges; and protect trunk loading area against damage caused by luggage, golf clubs and athletic gear.',
          'alias': 'wear-tear-premium',
          visible: false
        },
        {'title':'Wear & Tear',
          'description':'Protect paint behind door handles from ring and key scratches. Help prevent damage to door edges.',
          'alias': 'wear-tear',
          visible: false
        },
        {'title':'Full Roof',
          'description':'Protect the full roof against damage caused by rock chips, insects, and other debris. Have SunTek Altered Black PPF installed to full roof for customization and a two-tone look.',
          'alias': 'full-roof',
          visible: false
        },
        {'title':'Roof',
          'description':'Protect roof line and pillars against damage from rock chips, insects and other road debris.',
          'alias': 'roof',
          visible: false
        },
      ],
      rearView: false,
    }
  },
  mounted: function () {
    const vm = this;
    vm.selectedVehicleType = vm.vehicleTypes[0];
    vm.selectedPpfOption = vm.ppfOptions[1];
    /*
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if(isJustShown){
      }
    })
     */
  },
  computed: {
    currentVisualizerImage() {
     //@TODO - Logic for Default No Selection / Or Maybe Show a Placeholder
     const vm = this;
     if(vm.selectedVehicleType){
       if(vm.selectedPpfOption){
         if(vm.rearView){
           return vm.selectedVehicleType.vehicleImageBase+'/rear/'+vm.selectedPpfOption.alias+'.jpg';
         } else {
           return vm.selectedVehicleType.vehicleImageBase+'front/'+vm.selectedPpfOption.alias+'.jpg';
         }
       } else {
         if(vm.rearView){
           return vm.selectedVehicleType.vehicleImageBase+'rear/default.jpg';
         } else {
           return vm.selectedVehicleType.vehicleImageBase+'front/default.jpg';
         }
       }
     } else {
       return 'https://via.placeholder.com/300';
     }
    }
    },
  methods: {
    selectVehicle: function(vehicleType, index){
      const vm = this;
      vm.vehicleTypeIndex = index;
      vehicleType.active = !vehicleType.active;
      this.updateActiveButton(vehicleType.alias);
      vm.selectedVehicleType = vehicleType;
    },
    selectPPF: function(option){
      //@TODO - May need way to force the default option to come back
      option.visible = !option.visible;
      if(!option.visible){
        this.selectedPpfOption = false;
      } else {
        this.selectedPpfOption = option;
      }
    },
    changeView(){
     this.rearView = !this.rearView;
    },
    updateActiveButton(alias){
      this.vehicleTypes.forEach( v => {
        if (v.alias === alias) {
          v.active = true;
        } else {
          v.active = false;
        }
      });
    }
  },
}
</script>

<style scoped>
  .btn-tint-world-outline {
    border-color: black;
    color: black;
    font-weight: bold;
    border-width: 2px;
    -webkit-transition: all .3s ease-out;
    -o-transition: all .3s ease-out;
    transition: all .3s ease-out;
    text-transform:uppercase;
  }
  .btn-tint-world-outline:hover, .btn-tint-world-outline:focus, .btn-tint-world-outline:active {
    background: #fe0 !important;
    color:black !important;
  }
  .btn-tint-world {
    background: #fe0;
    -webkit-transition: all .3s ease-out;
    -o-transition: all .3s ease-out;
    transition: all .3s ease-out;
    color:black;
    font-weight:bold;
    text-transform:uppercase;
    border-color: black;
    border-radius:0px;
  }
  .btn-tint-world:hover,.btn-tint-world:focus,.btn-tint-world:active, .btn-tint-world.active-item {
    background: #000;
    background-color: #000 !important;
    border-color:black;
    color: white !important;
  }
  .accordion-top-copy {
    background: #ecececec;
    border-radius:0px;
    border-bottom: solid 2px black;
  }
  .ppf-copy-container {
    background-color:#ecececec;
  }
  .ppf-description {
    color: black;
    font-size: 15px;
    text-align: center;
  }
  .accordion-top-copy {
    font-size:18px;
  }
  .vehicle-image-wrapper {
    width: 100%;
    padding-top: 72.5%;
    position: relative;
  }
  img.vehicle-image {
    position: absolute;
    top: 0;
    left: 0;
  }
  @media(min-width:1025px){
    .vehicle-icon {
      max-width:20%;
    }
  }
  @media(max-width:1024px){
    .vehicle-icon {
      max-width:20%;
    }
  }
  @media(min-width:992px){
    .mobile-package-list {
      display:none;
    }
    .nobreak {
      white-space: nowrap;
    }
    .ppf-options-headline {
      font-size:22px;
    }
    .accordion-top-copy .card-body {
      padding:15px;
    }
    .accordion-top-copy p {
      line-height:normal;
    }
  }
  @media(max-width:991px){
    .desktop-package-list {
      display:none;
    }
    #ppf h3 {
      font-size:1.5rem;
    }
    .vehicle-image-wrapper {
      overflow: hidden;
    }
  }
  .mobile-ppf-description {
    font-size:14px;
    min-height:100px;
  }
  .row.bg-yellow {
    background: #fe0;
    margin-bottom:15px;
  }
  .ppf-header-headline {
    font-size:1rem;
    margin-top:5px;
    margin-bottom:5px;
  }
  .ppf-header-subline {
    font-size:1rem;
    margin-top:5px;
    margin-bottom:5px;
  }
  .bg-dark-gray {
    background-color:#ecececec;
  }
  a.icon {
    color:black;
    font-weight:bold;
    cursor:pointer;
  }
  .accordion-section-title {
    text-align:center;
    text-transform:uppercase;
    font-weight:bold;
    background:#666;
    color:white !important;
    border-radius:0px;
    padding:10px;
  }
</style>
